module.exports = __webpack_public_path__ + "img/amex.84efd56b.svg";